import { PagedResult, panelGet, panelPost, panelPut } from "./panel.api";
import { AddUserPayload, PanelUserRecord, UpdateRolesPayload } from "./types";

export interface UserListParams {
  page?: number;
  size?: number;
  searchText?: string;
  order?: string;
  orderBy?: string;
  /** false -> deactivated users, true -> active users. */
  isActive?: boolean;
  createdThrough?: string;
}

/** user-mgmnt — /user */
export const userApi = {
  /** Backs the Active / Deactivated tabs on Work Order User Management. */
  list: (params: UserListParams = {}) =>
    panelGet<PagedResult<PanelUserRecord>>("/user/get-user-list", {
      page: 0,
      size: 20,
      orderBy: "userName",
      ...params,
    }),
  activeUsers: (order: string = "asc", orderBy: string = "userName") =>
    panelGet<PanelUserRecord[]>("/user/get-active-user-list", { order, orderBy }),
  adminUsers: () => panelGet<PanelUserRecord[]>("/user/get-admin-user-list"),
  addUser: (payload: AddUserPayload) => panelPost("/user/add-user", payload),
  updateRoles: (payload: UpdateRolesPayload) => panelPut("/user/update-roles", payload),
  /** Both are POSTs with the id as a query param, not a body. */
  activate: (uniqueId: string) => panelPost("/user/user-activate", undefined, { uniqueId }),
  deactivate: (uniqueId: string) => panelPost("/user/user-de-activate", undefined, { uniqueId }),
  /** Access + roles for the signed-in user (the panel half of login). */
  userAccess: () => panelGet("/user/user-access"),
  profile: () => panelGet("/user/profile"),
  /** Validates an address before adding a user. */
  isValidEmail: (userEmail: string) => panelGet<boolean>("/user/is-valid-email", { userEmail }),
};
